/* MC Argollas — Grabado personalizado
   Contador/vista previa en producto, cargo de grabado ($) para anillos de compromiso
   y eliminación conjunta del cargo al quitar el anillo del carrito. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = function () { return ((window.MCTheme && window.MCTheme.routes && window.MCTheme.routes.root) || '/').replace(/\/$/, ''); };

  /* ---------- Página de producto: contador + vista previa ---------- */
  $$('[data-engraving]').forEach(function (box) {
    var input = $('[data-engraving-input]', box);
    var count = $('[data-engraving-count]', box);
    var prev = $('[data-engraving-preview]', box);
    var prevWrap = prev && prev.parentElement;
    var fontName = $('[data-engraving-font-name]', box);
    if (!input) return;
    function sync() {
      var v = input.value;
      if (count) count.textContent = v.length;
      var font = $('input[name="properties[Tipo de letra]"]:checked', box);
      var family = font && font.dataset.font ? font.dataset.font : 'inherit';
      if (prev) {
        prev.textContent = v;
        prev.style.fontFamily = family;
        prev.style.fontSize = (font && font.dataset.size) ? font.dataset.size : '';
        if (prevWrap) prevWrap.hidden = !v.trim();
      }
      if (fontName) fontName.textContent = font ? font.value : '';
    }
    input.addEventListener('input', sync);
    box.addEventListener('change', sync);
    sync();
  });

  /* ---------- Agregar al carrito (fase de captura, antes de global.js) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-product-form]') : null;
    if (!form) return;
    var box = $('[data-engraving]', form);
    if (!box) return;
    var input = $('[data-engraving-input]', box);
    var fontInputs = $$('input[name="properties[Tipo de letra]"]', box);
    var text = (input && input.value || '').trim();

    if (!text) {
      /* Sin grabado: no enviar propiedades vacías */
      if (input) input.disabled = true;
      fontInputs.forEach(function (i) { i.disabled = true; });
      setTimeout(function () {
        if (input) input.disabled = false;
        fontInputs.forEach(function (i) { i.disabled = false; });
      }, 0);
      return;
    }
    input.value = text;
    if (box.dataset.engravingMode !== 'paid' || !box.dataset.engravingFeeId) return;

    /* Grabado con costo: anillo + cargo en una sola petición */
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    var btn = form.querySelector('[data-add-button]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingText || '…'; }

    var fd = new FormData(form);
    var id = fd.get('id');
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    });
    props._grabado_fee = '1';
    var feeProps = {
      'Para': box.dataset.engravingProduct || '',
      'Grabado': text,
      'Tipo de letra': props['Tipo de letra'] || '',
      '_para_variant': String(id)
    };

    fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [
        { id: Number(id), quantity: qty, properties: props },
        { id: Number(box.dataset.engravingFeeId), quantity: 1, properties: feeProps }
      ] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (btn) btn.textContent = btn.dataset.addedText || original;
        if (window.MCCart && window.MCCart.refreshCartDrawer) return window.MCCart.refreshCartDrawer(true);
      })
      .catch(function () { window.location.href = (window.MCTheme && window.MCTheme.routes.cart) || '/cart'; })
      .then(function () {
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1600);
      });
  }, true);

  /* ---------- Carrito: al quitar un anillo, quitar también su cargo de grabado ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-cart-remove],[data-qty-change]') : null;
    if (!el) return;
    var line = Number(el.dataset.line);
    if (!line) return;
    if (el.hasAttribute('data-qty-change')) {
      var inp = $('[data-qty-input][data-line="' + line + '"]');
      if (!inp) return;
      var q = Math.max(0, parseInt(inp.value, 10) + parseInt(el.dataset.qtyChange, 10));
      if (q > 0) return; /* cambio normal de cantidad: lo maneja global.js */
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    fetch(root() + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items[line - 1];
        if (!item) return;
        var updates = {};
        updates[item.key] = 0;
        var p = item.properties || {};
        if (p._grabado_fee) {
          cart.items.forEach(function (it) {
            var ip = it.properties || {};
            if (ip._para_variant && String(ip._para_variant) === String(item.variant_id)) updates[it.key] = 0;
          });
        }
        return fetch(root() + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () { if (window.MCCart && window.MCCart.refreshCartDrawer) return window.MCCart.refreshCartDrawer(false); })
      .then(function () { if (document.body.classList.contains('template-cart')) window.location.reload(); });
  }, true);
})();
